import type { GeoJsonFeatureCollection, LngLatCoord, MapFeatureMapStyle } from '@gpx-spa/geo-domain'

export function lineStringFeatureCollection(
  coordinates: LngLatCoord[],
  map: MapFeatureMapStyle
): GeoJsonFeatureCollection {
  return {
    type: 'FeatureCollection',
    features: [
      {
        type: 'Feature',
        properties: { map },
        geometry: { type: 'LineString', coordinates },
      },
    ],
  }
}

export function polygonFeatureCollection(
  geometry: GeoJsonFeatureCollection['features'][0]['geometry'],
  map: MapFeatureMapStyle
): GeoJsonFeatureCollection {
  return {
    type: 'FeatureCollection',
    features: [
      {
        type: 'Feature',
        properties: { map },
        geometry,
      },
    ],
  }
}
